import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * PasswordInput — Input de contraseña con botón de ojo para mostrar/ocultar.
 * Acepta cualquier prop que reciba Input (value, onChange, placeholder, className, data-testid, etc.).
 */
export default function PasswordInput({ className = "", testid, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        data-testid={testid}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-700 transition-colors"
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        data-testid={testid ? `${testid}-toggle` : undefined}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
